import { jsx } from 'react/jsx-runtime';
import { withEventHandling } from '../../wrappers/withEventHandler.js';
import { Link } from '@vp/swan';
import 'react';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target};return _extends.apply(this,arguments)}const WrappedLink=withEventHandling(props=>jsx(Link,_extends({},props)));

export { WrappedLink as Link, WrappedLink };
//# sourceMappingURL=WrappedLink.js.map
